import { Flex, Grid, GridItem, Icon, Image, Text } from '@chakra-ui/react';
import { AiFillCheckCircle } from 'react-icons/ai';
import { PaymentMethod } from '~/lib/payment';
import { PaymentMethodVariables } from '~/types/payment';

type Props = {
  payment_methods: PaymentMethod[];
  selected_method: PaymentMethodVariables | null;
  onSelect: (method: PaymentMethodVariables) => void;
};

export const PaymentForm: React.FC<Props> = (props: Props) => {
  let didShowCarrierButton = false;

  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={3} w="full">
      {props.payment_methods.map((method: PaymentMethod) => {
        if (
          method.id == 'carriers:au' ||
          method.id == 'carriers:docomo' ||
          method.id == 'carriers:softbank'
        ) {
          if (didShowCarrierButton) {
            return;
          }
          didShowCarrierButton = true;
        }
        return (
          <PaymentMethodRow
            key={method.id}
            method={method}
            selectedMethod={props.selected_method}
            onSelect={props.onSelect}
          />
        );
      })}
    </Grid>
  );
};

const PaymentMethodRow: React.FC<{
  method: PaymentMethod;
  selectedMethod: PaymentMethodVariables | null;
  onSelect: (value: string) => void;
}> = (props) => {
  const { method, selectedMethod, onSelect } = props;

  return (
    <GridItem key={method.id} onClick={() => onSelect(method.id)}>
      <Flex
        flexDir="column"
        borderWidth="1px"
        borderColor={selectedMethod === method.id ? 'primary' : 'border'}
        rounded="10px"
        position="relative"
      >
        <Flex
          h="60px"
          mt="16px"
          w="full"
          align="center"
          justify="center"
          px="16px"
        >
          {method.icon_image ? (
            <Image
              src={method.icon_image}
              alt="icon"
              maxH="60px"
              w="40%"
              color={selectedMethod === method.id ? 'primary' : 'disable'}
            />
          ) : (
            <Icon maxH="60px" w="70%" as={method.icon} />
          )}
        </Flex>
        <Text
          w="full"
          my="12px"
          fontSize="13px"
          fontWeight="bold"
          textAlign="center"
        >
          {method.display_name}
        </Text>
        <Flex position="absolute" top={0} left={0} p="4px">
          <Icon
            as={AiFillCheckCircle}
            color={selectedMethod === method.id ? 'primary' : 'gray.300'}
            w={6}
            h={6}
          />
        </Flex>
      </Flex>
    </GridItem>
  );
};
